import React from 'react'

import { Text } from '@wartek-id/text'

import { MILKvKeys, useGetKeyPairValue } from 'api/microlearning/useAPIKeyValue'

interface InfoUpdatedTopicProps {
  isEnabled?: boolean
  message: string
  action: string
  url: string
}

const InfoUpdatedTopic = ({
  parentClass = '',
  onUpdated,
  isForceShow,
}: {
  parentClass?: string
  onUpdated?: (val: boolean) => void
  isForceShow?: boolean
}) => {
  const getUpdateInfo = useGetKeyPairValue(
    MILKvKeys.TopicListUpdateInformation,
    true,
    {
      staleTime: Infinity,
    }
  )

  const data = getUpdateInfo.data?.data as InfoUpdatedTopicProps

  React.useEffect(() => {
    if (data?.isEnabled) {
      onUpdated?.(data.isEnabled)
    }
  }, [data?.isEnabled, onUpdated])

  if ((!data?.isEnabled && !isForceShow) || getUpdateInfo.isLoading) {
    return null
  }

  return (
    <div className={'bg-surface-informational-subdued p-4 flex ' + parentClass}>
      <div className="mr-3 flex-shrink-0">
        <img
          src="https://mil-kv.guru.belajar.id/web-assets/img-announcement-speaker.png"
          height={32}
          width={32}
          alt="Info"
        />
      </div>
      <div>
        <Text variant="body-bold">{data?.message}</Text>

        <a href={data?.url} className="mt-1 block">
          <Text variant="body" className="!text-icon-informational underline">
            {data?.action}
          </Text>
        </a>
      </div>
    </div>
  )
}

export default InfoUpdatedTopic
